import { render, staticRenderFns } from "./TTSExport.vue?vue&type=template&id=c43b0aa8&"
import script from "./TTSExport.vue?vue&type=script&lang=js&"
export * from "./TTSExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports